import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../../stores/NavigateStore";

export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    topBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff',
        borderRadius: 8,
        height: 170,
        marginBottom: 20,
        '& .MuiStepIcon-root': {
            width: 40,
            height: 40,
        },
        '& .MuiStepConnector-alternativeLabel': {
            top: 20,
            left: 'calc(-50% + 30px)',
            right: 'calc(50% + 30px)',
        }
    },
    activeStepIcon: {
        width: '80%',
        '& .MuiStepIcon-active': {
            color: '#5579f0', // 활성 스텝 아이콘 색상 변경
        },
        '& .MuiStepIcon-completed': {
            border: '1px solid #5579f0',
            borderRadius: '100%',
            color: '#fff'
        },
    },
    boxWrap: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        height: 'calc(100vh - 350px)',
        overflowY: 'auto',
        // height: 'calc(100vw - 1580px)',
        width: '100%',
    },
    rightBoxWrap: {
        background: '#fff',
        marginLeft: 10,
        width: '100%',
        maxWidth: '720px',
        height: 'calc(100vh - 350px)',
        overflowY: 'auto',
        borderRadius: 8,
        padding: 20,
        '& .MuiTypography-root': {
            fontSize: '1.063rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
        }
    },

    tabBox: {
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#5579f0',
            opacity: 1,
            boxSizing: 'border-box',
            background: '#fff',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#5579f0'
        }
    },
    textBox: {
        '& .MuiBox-root': {
            padding: '10px 0px 0px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
            }
        }
    },
    disabled: {
        display: 'flex',
        justifyContent: 'right',
        '&.MuiBox-root': {
            padding: 0,
        },
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            minWidth: 104,
            height: 34,
            '&:hover': {
                background: 'rgba(16, 18, 28, 0.3)',
            },
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: 'rgba(255, 255, 255, 0.7)',
            }
        },
    },
    buttonStyle: {
        display: 'flex',
        justifyContent: 'right',
        '& .MuiButtonBase-root': {
            background: '#056CF2',
            color: '#fff',
            minWidth: 104,
            height: 34,
            '&:hover': {
                background: '#056CF2',
            },
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#fff'
            }
        }
    },
    textCutBoxContainer: {
        overflowY: 'auto',
        border: '1px solid #87888d',
        borderRadius: 8,
    },
    textCutBox: {
        position: 'relative',
        '&.MuiBox-root': {
            padding: '12px 14px',
            height: 150,
        },
        fontSize: 20,
        userSelect: 'none'
    },
    textSpace: {
        cursor: 'pointer',
        backgroundColor: 'transparent',
        transition: 'background-color 0.3s ease',
        '&:hover': {
            backgroundColor: '#c3c8e9',
        },
    },
    cuttingPosition: {
        position: 'absolute',
        top: 18,
        left: 180,
        display: 'block',
        width: '20px'
    },
    uncomplete: {
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '&:hover': {
                background: 'rgba(16, 18, 28, 0.3)',
            },
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: 'rgba(255, 255, 255, 0.7)',
            }
        }
    },
    complete: {
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '&:hover': {
                background: '#f27c57',
            },
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#fff',
            }
        }
    },
    buttonGroup: {
        marginTop: 10,
    },
    listButtonStyle: {
        '& .MuiButtonBase-root': {
            '&:hover': {
                background: 'transparent'
            },
        },
        '& .MuiTypography-root': {
            marginLeft: 5,
            fontSize: '1rem',
            fontWeight: 'bold',
            letterSpacing: '-0.62px',
            color: '#10121c',
        }
    },
    buttonStyle2Active: {
        '& .MuiButtonBase-root': {
            border: '1px solid #5579f0',
            borderRadius: 4,
            background: '#fff',
            width: 100,
            height: 48,
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#5579f0'
            }
        }
    },
    buttonStyle2: {
        '& .MuiButtonBase-root': {
            border: '1px solid #bcbcbc',
            borderRadius: 4,
            background: '#fff',
            width: 100,
            height: 48,
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#bcbcbc'
            }
        }
    },
    buttonStyle3: {
        '& .MuiButtonBase-root': {
            border: '0px solid #5579f0',
            background: 'rgba(16, 18, 28, 0.3)',
            marginLeft: 16,
            width: 100,
            height: 48,
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#fff'
            }
        }
    },
    buttonStyle3Active: {
        '& .MuiButtonBase-root': {
            border: '0px solid #5579f0',
            background: '#5579f0',
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#fff'
            }
        }
    },
    backButton: {
        background: '#fff',
        boxShadow: 'none',
        '&:hover': {
            background: 'transparent',
            boxShadow: 'none',
        }
    },
    textContnetScroll: {
        // overflowY: 'auto',
        // height: 'calc(100vh - 645px)',
    },
    textContnetBox: {
        marginTop: 10,
        '& .MuiTypography-root': {
            fontSize: '0.938rem',
            letterSpacing: '-0.5px',
            color: '#10121c',
            fontWeight: 600,
            marginBottom: 10,
        }
    },
    textContnet: {
        border: '1px solid #87888d',
        borderRadius: 8,
        '&.MuiBox-root': {
            padding: 0,
        },
        '& .MuiBox-root': {
            borderBottom: '1px solid #87888d',
            padding: '3px 10px',
            minHeight: 36,
            boxSizing: 'border-box',
            '& .MuiTypography-root': {
                fontWeight: 'normal',
                letterSpacing: '-0.5px',
                color: '#000',
                marginBottom: 0,
                lineHeight: '29px',
                '& span': {
                    background: '#87888d',
                    color: '#fff',
                    borderRadius: '100%',
                    width: 25,
                    height: 25,
                    display: 'inline-block',
                    fontSize: '0.875rem',
                    fontWeight: 'bold',
                    lineHeight: '24px',
                    textAlign: 'center',
                    marginRight: 5,
                }
            }
        },
        '& .MuiBox-root:last-child': {
            borderBottom: '0px',
        }
    },
    borderActive: {
        outline: '3px solid #5579f0',
    },
    imageBox: {
        marginTop: 9,
    },
    iconButtonStyle: {
        display: 'flex',
        justifyContent: 'end',
        paddingTop: 33,
        '& .MuiIconButton-root': {
            padding: 0,
            marginBottom: 14,
            '&:hover': {
                background: 'transparent',
            }
        }
    },
    rightTextBox: {
        '& .MuiFormControl-root': {
            width: '100%',
            marginBottom: 10,
            '& .MuiInputBase-root': {
                borderRadius: 8,
                '& input':{
                    padding: '8px 13px 8px 0',
                    fontSize: '1.125rem',
                    letterSpacing: '-0.5px',
                    color: '#323232',
                    '&::placeholder':{
                        opacity: 1,
                        color: 'red'
                    }
                },
            },
        }
    },
    imageContent: {
        border: '1px solid #bcbcbc',
        // height: 550,
        height: '100%',
        marginBottom: 10,
        overflow: 'hidden',
        position: 'relative',
        '& img': {
            width: '100%',
            marginTop: '-1px',
            objectFit: 'contain',
        }
    },
    imageBackground: {
        position: 'absolute',
        width: '100%',
        // height: 550,
        height: '100%',
        background: 'rgba(0, 0, 0, 0.5)',
        pointerEvents: 'none'
    },
    imageNumber: {
        position: 'absolute',
        width: 38,
        height: 38,
        borderRadius: '100%',
        background: '#fff',
        // top: 100,
        // left: 20,
        '& .MuiTypography-root': {
            fontSize: '1.375rem',
            fontWeight: 'bold',
            textAlign: 'center',
            lineHeight: '37px',
        }
    },
    imageTitle: {
        '&.MuiTypography-root': {
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
            fontSize: '1.063rem',
            marginBottom: 10,
        }
    },
    popoverTooltip: {
        '& .MuiPopover-paper': {
            background: '#365edf',
            color: '#fff',
            minWidth: 343,
            minHeight: 106,
            padding: '10px 10px 10px 15px',
            overflow: 'visible',
            marginTop: 15,
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '15px',
            lineHeight: '21px',
            letterSpacing: '-0.5px',
        }
    },
    formControl:{
        '&.MuiFormControl-root ':{
            margin: 0,
            width: 110,
            marginRight: 12,
        },
        '& .MuiSelect-select':{
            width: 110,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing:'border-box',
            color:'#777',
            letterSpacing: '-0.5px',
            display:'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px #87888d',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select':{
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    selectPopover:{
        '& .MuiPaper-root':{
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing:'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root':{
            width: '100%',
            display: 'flex',
            fontSize: '1.125rem',
            color:'#323232',
            boxSizing: 'border-box',
            '&:hover':{
                background: '#eee !important'
            },
            '&.Mui-selected':{
                background: '#eee'
            },
        }
    },
    tooltipTop: {
        position: 'absolute',
        top: -10,
        left: '50%',
        color: '#000'
    },
    tooltipBtn: {
        '& .MuiButtonBase-root': {
            padding: 0,
            minWidth: 'auto',
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    oddTextBox: {
        border: '1px solid #87888d',
        borderRadius: 8,
        height: 150,
        position: 'relative',
        '&.MuiBox-root': {
            padding: 13,
            marginTop: 10,
        },
        '& .MuiTypography-root': {
            color: '#000',
            letterSpacing: '-0.2px',
            '& span': {
                background: 'rgba(242, 124, 87, 0.7)'
            }
        },
    },
    volumeIconPosition: {
        '&.MuiIconButton-root': {
            position: 'absolute',
            bottom: 5,
            right: 10,
            padding: 0,
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    selectBoxListening: {
        '&.MuiBox-root': {
            padding: 0,
        },
    },
    refreshIcon: {
        '&.MuiIconButton-root': {
            padding: 0,
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    volumeIcon: {
        '&.MuiIconButton-root': {
            padding: 0,
            '&:hover': {
                background: 'transparent'
            }
        }
    }



}));

